export default {
  'construction.png': 'construction.png',
  'exclamation.png': 'exclamation.png',
  'light-bulb.png': 'light-bulb.png',
  'lock.png': 'lock.png',
  'loudspeaker.png': 'loudspeaker.png',
  'no-entry.png': 'no-entry.png',
  'party-popper.png': 'party-popper.png',
  'sparkles.png': 'sparkles.png',
  'thumbs-up.png': 'thumbs-up.png',
}
